import DiffViewer from './DiffViewer';

export default DiffViewer;
